// 封装localStorsge本地储存方法
const storage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        if(!['undefined','null'].includes(localStorage.getItem(key))){
            return JSON.parse(localStorage.getItem(key))
        }else{
            return false
        }
    },
    remove(key) {
        localStorage.removeItem(key)
    }
}
export default storage